import React, { Component } from 'react'
import { View, StyleSheet, Platform } from 'react-native'
import { JDText, JDImage, JDDevice, JDTouchable } from '@jdreact/jdreact-core-lib'

import PropTypes from "prop-types"
import { zufangCall } from '../../../utils/callPhone'

import {
  detailTel
} from '../../../utils/image'

export default class brokerItem extends Component{
	static contextTypes = {
		router: PropTypes.object
	};
	static propTypes = {
		brokerInfo: PropTypes.object,
		telPhone: PropTypes.string,
		extentionPhone: PropTypes.string,
	};
	// 唤起打电话功能
	telCall = () => {
		let { telPhone, extentionPhone } = this.props;
		zufangCall(extentionPhone, telPhone);
	};

	render() {
		let {
			headImg, name, con, 
		} = this.props.brokerInfo || {};
		return (
				<View style={brokerStyles.brokerContainer }>
					<View style={brokerStyles.imgBox}>
						<JDImage
								style={brokerStyles.headPic}
								source={{uri:headImg}}
						></JDImage>
					</View>
					<View style={[brokerStyles.brokerRight]}>
						<View style={brokerStyles.brokerMes}>
							<View style={[brokerStyles.brokerRow]}>
									<JDText numberOfLines={1} ellipsizeMode={'tail'} style={brokerStyles.brokerName}>{name}</JDText>
							</View>
							<View style={brokerStyles.brokerComBox}><JDText style={brokerStyles.brokerComText}>{con}</JDText></View>
						</View>
					</View>
					<JDTouchable style={brokerStyles.telCallCon} onPress={this.telCall}>
						<JDImage style={brokerStyles.telCall} source={detailTel}></JDImage>
					</JDTouchable>
				</View>
		)
	}
}
const brokerStyles = StyleSheet.create({
	brokerContainer:{
		display: 'flex',
		flexDirection:'row',
		width: '100%',
		height: JDDevice.getRpx(120),
		paddingBottom: JDDevice.getRpx(30),
		borderTopWidth: JDDevice.getDpx(1),
		borderStyle: 'solid',
		borderColor: '#ffffff'
	},
	imgBox: {
		position: 'relative',
		width: JDDevice.getRpx(90),
		alignItems: 'center'
	},
	headPic:{
    width:JDDevice.getRpx(90),
		height:JDDevice.getRpx(90),
		borderRadius: JDDevice.getRpx(46)
  },
	brokerRight:{
		flex:1,
		flexDirection:'row',
		marginLeft: JDDevice.getRpx(24),
		maxWidth: JDDevice.getRpx(400),
	},
	brokerMes:{
		flex: 1,
		height: JDDevice.getRpx(89),
		justifyContent:"center"
	},
	brokerRow: {
		flexDirection:'row',
		alignItems: "center",
		height: JDDevice.getRpx(40),
		marginTop: JDDevice.getRpx(8)
	},
	brokerName:{
		fontSize: JDDevice.getRpx(28),
		marginRight: JDDevice.getRpx(10),
		maxWidth: JDDevice.getRpx(174),
		fontWeight: 'bold',
		color: '#1a1a1a'
	},
	brokerComBox: {
		flexDirection:'row',
		alignItems: "center",
		height: JDDevice.getRpx(40),
	},
	brokerComText: {
		fontSize: JDDevice.getRpx(24),
		color: '#808080',
	},
	telCallCon:{
		position: 'absolute',
		bottom: JDDevice.getRpx(30),
		right: 0
	},
	telCall:{
		marginBottom: JDDevice.getRpx(14),
		width:JDDevice.getRpx(64),
		height:JDDevice.getRpx(64),
	},

});
